import { defineComponent } from 'vue';
import { FormRules, NAlert, NButton, NForm, NFormItem, NInput, NSpin, NDivider, FormItemRule } from 'naive-ui';
import { mapStores } from 'pinia';
import { useAuthStore } from '~/store/auth.store';

export default defineComponent({

    components: {
        NButton,

        NForm,
        NFormItem,

        NInput,
        NSpin,
        NAlert,

        NDivider,
    },

    data() {
        return {
            result: {
                email: '',
                password: '',
                passwordRepeat: '',
            },
            messages: {
                required: this.$t('reset_password.form.required'),
            },
            
            rules: {
                email: { required: true, trigger: ['submit']},
                password: [
                    { 
                        required: true, 
                        trigger: ['input', 'blur']
                    },
                    {
                        validator: (rule, value) => value.length >= 8,
                        message: this.$t('register.password_too_short'),
                        trigger: ['input', 'blur']
                    },
                    {
                        validator: (rule, value) => (/[A-Z]/.test(value)),
                        message: this.$t('register.password_has_no_uppercase'),
                        trigger: ['input', 'blur']
                    },
                    {
                        validator: (rule, value) => (/[a-z]/.test(value)),
                        message: this.$t('register.password_has_no_lowercase'),
                        trigger: ['input', 'blur']
                    },
                    {
                        validator: (rule, value) => (/[0-9]/.test(value)),
                        message: this.$t('register.password_has_no_digit'),
                        trigger: ['input', 'blur']
                    },
                    {
                        validator: (rule, value) => (/[$@$!%*#?&,;]/.test(value)),
                        message: this.$t('register.password_has_no_special_character'),
                        trigger: ['input', 'blur']
                    },
                ],
                'passwordRepeat': [
                    { 
                        required: true,
                        trigger: ['input', 'blur']
                    },
          
                    {
                        validator: (rule: FormItemRule, value: string) => {
                            return value === this.result.password;
                        },
                        message: this.$t('register.error.password_different'),
                        trigger:  ['blur', 'password-input']
                    }
                ]
            } as FormRules,
            failed: false,

            loading:false,
            success: false,
            valid: false,
            error: null,
        };
    },


    computed: {
        ...mapStores(useAuthStore),
        logo() {
            return require('./../../../img/avolta-connect-logo.png').default;
        },
    },

    methods: {
        onSubmit(e: Event) {

            if(!this.valid) {
                return;
            }

            e.preventDefault();
            this.error = false;
            this.loading = true;
            this.authStore.register(this.result?.email, this.result.password)
                .then(() => {
                    this.success = true;
                    this.$router.push({ name: 'login'});
                })
                .catch((error: Error) => {
                    this.error = error.message;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },

    watch: {
        result: {
            handler() {
                //@ts-ignore
                this.$refs?.form?.validate((errors) => {
                    this.valid = !errors;
                })
                .catch((err: Error) => {
                    if (err) {
                        this.valid = false;
                    }
                });
            },
            deep: true,
        }
    }
});